/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Route zu meinen Favoriten hinzufügen`
};

const en_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Add this route to my favourites`
};

const es_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Añadir este itinerario a favoritos`
};

const fr_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouter cet itinéraire à mes favoris`
};

const it_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi questo itinerario ai preferiti`
};

const nl_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Deze route toevoegen aan mijn favorieten`
};

const pt_bookmark__add__itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Adicionar este itinerário aos meus favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__add__itinerary(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__add__itinerary", locale)
	if (locale === "de") return de_bookmark__add__itinerary(inputs)
	if (locale === "en") return en_bookmark__add__itinerary(inputs)
	if (locale === "es") return es_bookmark__add__itinerary(inputs)
	if (locale === "fr") return fr_bookmark__add__itinerary(inputs)
	if (locale === "it") return it_bookmark__add__itinerary(inputs)
	if (locale === "nl") return nl_bookmark__add__itinerary(inputs)
	return pt_bookmark__add__itinerary(inputs)
};